var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 11.2,
    viewBox: "0 0 14 11.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.5,8.5l4.5-3-4.5-3v6Zm-4.5,2.7c-.3,0-.5-.1-.7-.3-.2-.2-.3-.5-.3-.8V1c0-.3.1-.5.3-.7.2-.2.5-.3.7-.3h11.9c.3,0,.5.1.7.3.3.2.4.5.4.7v9.1c0,.3-.1.5-.3.7s-.5.3-.7.3H1v.1Zm0-1.1h11.9V1H1v9.1Zm0,0V1v9.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.f6bf3e8fcab05d7c91e6b28820193d24.svg";
export { ForwardRef as ReactComponent };